module.exports = __webpack_public_path__ + "img/happy-news.97fd742a.svg";